import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img 
            src="/logo/logo.png" 
            alt="Babylon Logo" 
            className="footer-logo"
          />
          <h3 className="footer-title">Babylon Group</h3>
        </div>
        <div className="footer-section">
          <p className="footer-description">
            Business Intelligence & Analytics
          </p>
          <p className="footer-copyright">
            © {currentYear} Babylon Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

